import React, { useEffect } from 'react';
import { number } from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getMemos } from 'Redux/modules/webChat/memo/actions';

import EmptyList from '../EmptyList';
import HOCList from '../HOCList';

import MemoItem from './MemoItem';
import style from './Memo.less';

const Memo = ({ conversationId }) => {
  const dispatch = useDispatch();
  const { meta, list } = useSelector(state => state.webChat.memo, shallowEqual);

  const page = meta?.pagination?.page || 0;
  const pages = meta?.pagination?.pages || 0;
  const isLoadMore = page < pages;

  const getListMemo = (curPage, loadMore) => {
    dispatch(getMemos(conversationId, { page: curPage, pageSize: 30 }, loadMore));
  };

  const onEnter = () => {
    if (isLoadMore) {
      getListMemo(page + 1, true);
    }
  };

  useEffect(() => {
    getListMemo(1, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className={style.list}>
        <HOCList onEnter={onEnter} isLoadMore={isLoadMore}>
          {list.map(item => (
            <MemoItem key={item.id} item={item} />
          ))}
        </HOCList>
        {meta?.pagination?.total === 0 && <EmptyList text="No memos yet" />}
      </div>
    </div>
  );
};

Memo.propTypes = {
  conversationId: number.isRequired,
};

Memo.defaultProps = {};

export default Memo;
